import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable, map } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { SurefireSystem } from 'src/app/shared/interfaces/system.interface'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class SystemService {
    #httpClient = inject(HttpClient)

    getSystemInformation(): Observable<SurefireSystem> {
        return this.#httpClient
            .get<ApiResponse<SurefireSystem>>(`${environment.baseUrl}system`)
            .pipe(map((x) => x.result))
    }
}
